import * as PropTypes from 'prop-types';
import * as React from 'react';

class BuyerDetails extends React.Component {
  constructor(props) {
    super(props);

    this.setFirstName = this.setFirstName.bind(this);
    this.setLastName = this.setLastName.bind(this);
    this.setEmail = this.setEmail.bind(this);
    this.setAcceptsEmailMarketing = this.setAcceptsEmailMarketing.bind(this);
  }

  setFirstName(e) {
    this.props.onChange({ firstName: e.target.value });
  }

  setLastName(e) {
    this.props.onChange({ lastName: e.target.value });
  }

  setEmail(e) {
    this.props.onChange({ email: e.target.value });
  }

  setAcceptsEmailMarketing(e) {
    this.props.onChange({ acceptsEmailMarketing: e.target.checked });
  }

  render() {
    return (
      <div className="g-container mb-1">
        <div className="g-col-6">
          <label>{I18n.t('emailOffers.buyerDetails.firstName')}</label>
          <input
            type="text"
            className="wide required"
            defaultValue={this.props.buyer.firstName}
            onChange={this.setFirstName}
            name="buyer_first_name"
          />
        </div>
        <div className="g-col-6">
          <label>{I18n.t('emailOffers.buyerDetails.lastName')}</label>
          <input
            type="text"
            className="wide required"
            defaultValue={this.props.buyer.lastName}
            onChange={this.setLastName}
            name="buyer_last_name"
          />
        </div>
        <div className="g-col-12">
          <label>{I18n.t('emailOffers.buyerDetails.email')}</label>
          <input
            type="text"
            className="wide required"
            defaultValue={this.props.buyer.email}
            onChange={this.setEmail}
            name="buyer_email"
          />
        </div>
        <div className="g-col-12">
          <div className="label-with-checkbox">
            <input
              id="accepts_email_marketing_checkbox"
              name="accepts_email_marketing_checkbox"
              type="checkbox"
              defaultChecked={this.props.buyer.acceptsEmailMarketing}
              onChange={this.setAcceptsEmailMarketing}
            />
            <label
              htmlFor="accepts_email_marketing_checkbox"
              className="normal"
            >
              {I18n.t('emailOffers.buyerDetails.acceptsEmailMarketing')}
            </label>
          </div>
        </div>
      </div>
    );
  }
}

BuyerDetails.propTypes = {
  buyer: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    acceptsEmailMarketing: PropTypes.bool,
  }),
  onChange: PropTypes.func.isRequired,
};

export default BuyerDetails;



// WEBPACK FOOTER //
// ./javascripts/components/dashboard/selling/email_offers/buyer_details.jsx